import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { ui } from '../../../utils/uiTokens'

// Жалақы менторов басшы не видит. Здесь будет его собственная жалақы.
const HeadSalaryPage = () => {
    const { formatMessage } = useIntl()
    return (
        <Box sx={{ margin: '10px' }}>
            <Box sx={{ background: ui.card, border: `1px solid ${ui.border}`, borderRadius: '16px', padding: '24px', minHeight: '80vh' }}>
                <H3>{formatMessage({ id: 'headSalary' })}</H3>
                <Box sx={{ color: ui.muted, fontSize: '14px', marginTop: '40px', textAlign: 'center' }}>
                    {formatMessage({ id: 'headSalarySoon' })}
                </Box>
            </Box>
        </Box>
    )
}

export default HeadSalaryPage
